import { copyHtmlToClipBoard } from '@/utils/strings'
import { useState } from 'react'
import { useTranslation } from '@/utils/useTranslation'
import tw from 'twin.macro'

export interface Props {
  id?: string
  text?: string
  theme?: 'dark' | 'light'
}

export default function CopyButton({ id, text, theme = 'dark' }: Props) {
  const [copied, setCopied] = useState(false)
  const { t } = useTranslation()

  return (
    <button
      type="button"
      tw="flex items-center justify-center opacity-80 hover:!opacity-100 transition-opacity"
      css={theme === 'dark' ? tw`text-tealBlue` : tw`text-primaryBlue`}
      title="Copy Text"
      aria-label="Copy Text"
      onClick={(): void => {
        text ? navigator.clipboard.writeText(text) : copyHtmlToClipBoard(document.getElementById(id).innerHTML)
        setCopied(true)
        setTimeout(() => setCopied(false), 3000)
      }}
    >
      <span tw="text-[0.9375rem] italic mr-2">{copied ? t('Copied!') : t('Copy')}</span>
      <span tw="font-bwi">&#xe905;</span>
    </button>
  )
}
